<template>
    <BulmaAccordion
        dropdown
        :icon="'caret'"
        :caretAnimation="{
        duration: '.6s',
        timerFunc: 'ease-in-out'
    }"
        :slide="{
        duration: '.9s',
        timerFunc: 'ease'
    }"
    >
        <HiwAccordionItems :accordion="accordion" v-for="(accordion, i) in accordionitem.accordionLists" :key="i" />
    </BulmaAccordion>
</template>

<script>
    import { BulmaAccordion } from 'vue-bulma-accordion'
    import HiwAccordionItems from "./HiwAccordionItems";

    export default {
        name: "HiwAccordion",
        props: ['accordionitem'],
        components: {
            HiwAccordionItems,
            BulmaAccordion,
        }
    }
</script>

<style scoped>

</style>